import React from "react";
import * as Dialogs from "oc-ui/dialogs/Dialogs";
import Select from "react-select";
import * as Commons from "oc-commons/Commons";
import { Image } from "./Image";
import { I18N } from "oc-I18N";
import { MAuswahl, MAuswahlwert } from "../../metamodell";

export function InfoIcon({ Text, Bild }: { Text?: string; Bild?: string }) {
  if (Commons.isEmpty(Text) && Commons.isEmpty(Bild)) {
    return null;
  }
  return (
    <button
      className="icon-info-circle info-tooltip-button"
      aria-label={I18N("aria::Informationen anzeigen")}
      onClick={() => {
        Dialogs.showDialog({
          content: (
            <div className="numberSelect-info flex-row flex-center">
              <div className="text" dangerouslySetInnerHTML={{ __html: Text }}></div>
              <Image url={Bild} />
            </div>
          ),
          buttonAndActionList: [
            {
              label: I18N("OK"),
              primary: true,
              action: () => {},
            },
          ],
        });
      }}
    ></button>
  );
}

export function NumberSelect({
  title = undefined,
  value,
  onChange,
  minAnzahl = undefined,
  maxAnzahl = undefined,
  auswahl = undefined,
  auswahlwert = undefined,
}: {
  title?: string;
  value: number;
  onChange?: (value: number) => void;
  minAnzahl?: number;
  maxAnzahl?: number;
  auswahl?: MAuswahl;
  auswahlwert?: MAuswahlwert;
}) {
  const createNumericOptions = () => {
    const numericOptions = [];
    for (let i = minAnzahl; i <= maxAnzahl; i++) {
      const optionElement = {
        value: i,
        wert: i,
        label: (
          <div className="dropdown-entry">
            <div className="text">
              <span>{i}</span>
            </div>
            {!Commons.isEmpty(auswahlwert?.Auswahlbild) && <Image url={auswahlwert?.Auswahlbild} />}
          </div>
        ),
      };
      numericOptions.push(optionElement);
    }
    return numericOptions;
  };

  const options = createNumericOptions();

  return (
    <React.Fragment>
      <div
        className="NumberSelect"
        role="group"
        aria-labelledby={`numberSelectLabel-${title}`}
        aria-describedby={`numberSelectDesc-${title}`}
      >
        <div className="title">
          <span
            dangerouslySetInnerHTML={{
              __html: title ?? auswahl?.Text,
            }}
          ></span>
          <InfoIcon Text={auswahl?.Hilfstext ?? auswahlwert?.Artikelinfo} Bild={auswahl?.Bild} />
        </div>

        <div
          className="select-container"
          data-testid={`number-select-${title}`}
          aria-labelledby={`numberSelectLabel-${title}`}
          aria-describedby={`numberSelectDesc-${title}`}
          aria-label={I18N("Auswahl")}
        >
          <Select
            classNamePrefix="my-select"
            value={options.find((w) => w.wert == value)}
            options={options}
            onChange={(w) => onChange(w?.wert)}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
